import { jsx as l } from "react/jsx-runtime";
const h = (v) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...v,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.25 1.544v1.48h3.25v8.074L13 11.5l.402 1.5H9.9l1.5-1.5H13V8H3v3.5h1.612l1.5 1.5H1.5V3.025h3.25V1.544h1.5v1.48h3.5v-1.48h1.5ZM3 6.5h10V4.525h-1.75v.545l-1.5.403v-.948h-3.5v.57l-1.5.403v-.973H3V6.5Zm5.005 6.98L5.43 10.902 6.49 9.842l1.515 1.516 3.063-3.062 1.06 1.06-4.123 4.123Z",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  h as CalBook
};
